import React from "react";
import PropTypes from "prop-types";
import { useInstantSearch } from "react-instantsearch";

function NoResultsMessage({ customMessage = undefined, hits = [] }) {
  const { status } = useInstantSearch();
  const stillLoading = status === "loading" || status === "stalled";
  const hitsPresent = hits && hits.length > 0;

  if (stillLoading || hitsPresent) return null;

  return (
    <>
      {!customMessage && <div className="text-center p-4 fw-bold">No Results. Adjust your search and try again.</div>}
      {customMessage}
    </>
  );
}

NoResultsMessage.propTypes = {
  customMessage: PropTypes.element,
  hits: PropTypes.array, // eslint-disable-line react/forbid-prop-types
};

export default NoResultsMessage;
